@import "../../styles/app";

.loading {
  display: none;
}

